var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01229 24.0123C0.814538 24.0122 0.62124 23.9535 0.45683 23.8437C0.29242 23.7338 0.16428 23.5776 0.0886103 23.3949C0.0129402 23.2122 -0.00686305 23.0112 0.0317045 22.8172C0.0702721 22.6233 0.165479 22.4451 0.305288 22.3053L8.47729 14.1333C9.0397 13.5707 9.35565 12.8077 9.35565 12.0123C9.35565 11.2168 9.0397 10.4538 8.47729 9.89126L0.305288 1.71926C0.209778 1.62701 0.133596 1.51667 0.0811869 1.39466C0.0287779 1.27266 0.00119157 1.14144 3.77571e-05 1.00866C-0.00111606 0.87588 0.0241854 0.7442 0.0744663 0.621304C0.124747 0.498407 0.199 0.386755 0.292893 0.292863C0.386786 0.19897 0.498438 0.124717 0.621334 0.074436C0.744231 0.0241551 0.87591 -0.00114658 1.00869 7.23917e-06C1.14147 0.00116106 1.27269 0.0287473 1.39469 0.0811563C1.5167 0.133565 1.62704 0.209748 1.71929 0.305258L9.89129 8.47726C10.8274 9.41554 11.3532 10.6868 11.3532 12.0123C11.3532 13.3377 10.8274 14.609 9.89129 15.5473L1.71929 23.7193C1.5318 23.9068 1.27748 24.0122 1.01229 24.0123Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d1bcae6a01bbde6e4369333fa4a585ce.svg";
export { ForwardRef as ReactComponent };